import { Div, Flex, Heading } from "@hopper-ui/components";
import { MultipleChoiceRichIcon } from "@hopper-ui/icons";
import { InnerPage, PageLoading, SmartReportsListEmptyState, SmartReportsListItem, SmartReportsTeamInfo, useGetSmartReportSuspenseQuery, useSharedTranslation } from "@workleap-ai/shared";
import { Suspense } from "react";

const SmartReportsListPage = () => {
    return (
        <Suspense fallback={<PageLoading />}>
            <SmartReportsListPageChild />
        </Suspense>
    );
};

const SmartReportsListPageChild = () => {
    const { tShared } = useSharedTranslation();
    const { data: smartReport } = useGetSmartReportSuspenseQuery();

    return (
        <InnerPage
            content={
                <Div padding="inset-lg">
                    <Div
                        border="neutral-weak"
                        borderRadius="rounded-md"
                        paddingY="inset-xl"
                        paddingX="inset-md"
                    >
                        <Flex alignItems="center" gap="inline-md" paddingLeft="inset-md">
                            <MultipleChoiceRichIcon size="xl" />
                            <Heading>{tShared("smartReports.title")}</Heading>
                        </Flex>
                        <SmartReportsTeamInfo
                            paddingY="inset-md"
                            paddingX="inset-lg"
                            marginTop="stack-lg"
                        />
                        {!smartReport ?
                            <Div marginTop="stack-lg">
                                <SmartReportsListEmptyState />
                            </Div> :
                            <Flex direction="column" gap="inline-sm" marginTop="stack-md">
                                <SmartReportsListItem report={smartReport} />
                            </Flex>}
                    </Div>
                </Div>
            }
        />
    );
};

export default SmartReportsListPage;
